import React from 'react'
import { useAppContext } from '../context/AppContext';
import Header from '../components/Header';
// import ProfileMenu from '../components/profileMenu';
import { Outlet, useLocation } from 'react-router-dom';
import PatientSidebar from '../sidebar/PatientSidebar';
import { Box } from '@mui/system';

export default function PatientLayout(props) {
  const location = useLocation();
  const { isMobile, drawerOpen, } = useAppContext();
  const isChatRoute = location.pathname === "/chat";
  return (
    <React.Fragment>
      <Header />
      {/* <ProfileMenu /> */}
      <PatientSidebar />
      <div
        style={{
          // minHeight: isMobile ? "calc(100vh - 40px)" : "100vh",
          minHeight: "calc(100vh - 55px)",
          backgroundColor: "#FAFAF9",
          // backgroundImage: `url(${background})`,
          // backgroundSize: "cover",
          // backgroundPosition: isMobile ? "center -250px" : "center",
          // backgroundRepeat: "no-repeat",
          marginLeft: isMobile ? "0px" : !drawerOpen ? "280px" : "0px",
          marginTop: "55px",
        }}
      >
        {props.children}

        {/* Page content here */}
        <Box sx={{
          paddingX: isMobile ? "10px" : "20px",
          paddingY: isChatRoute ? "0px" : "20px",
        }}>
          <Outlet />
        </Box>
      </div>
    </React.Fragment>
  )
}
